import '../createContextUtilities/index.js';
import createContextUtilities from '../createContextUtilities/createContextUtilities.js';

const {
  Provider: PopperContextProvider,
  useContext: usePopperContext
} = createContextUtilities({
  isParentAnchorHidden: false
});

export { PopperContextProvider, usePopperContext as default };
